import { METHOD_API, createConnector, prefixApi } from "./Connector";

export const getColorData = () => {
  return createConnector(METHOD_API.GET, `${prefixApi}/color`, null);
};
